import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import VariableValueForm from "../types/VariableValueForm";

export const OrderDeliveryFeeForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  const input_configs = {
    type: "currency",
    prefix: "R$ ",
    suffix: "",
    precision: 2,
    min: 0,
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.OrderDeliveryFee}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <VariableValueForm
        node={node}
        input_configs={input_configs}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
